import type { FaireProductEntity } from "../../entity_types/product";

export const p_6yjlq7vx7c: FaireProductEntity = {
  token: "p_6yjlq7vx7c",
  type: "product",
  name: "Mini Tweed Pearly Florals Crossbody - Blue",
  brandToken: "b_2dugn0n0pu",
  brandName: "Bewaltz",
  imageUrl:
    "https://cdn.faire.com/fastly/2981cbe2e616995c7306844c1f5ee57d4ebe7641a6181aeb515a2cfe81d6bef6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e2052d09e1694a66e9768007c473322e366e0c8d1dcf2672db1e5002434cf93.jpeg",
    "https://cdn.faire.com/fastly/ccc3972cd0a2c956e63f50624571de437f2e39e1ff33c8f4086dfbf986a58666.jpeg",
    "https://cdn.faire.com/fastly/b6e863ef5fb0fed7951d764248acc40b97a644958ed21b98961be8ecab756857.jpeg",
    "https://cdn.faire.com/fastly/dcbdb29989a7f3e638b0aaa61eedf2b7265b89a0777ea30951044c8957a23d5a.jpeg",
    "https://cdn.faire.com/fastly/7e5a00879d46f7e3212b35d8a4220be717d6a9dbf103c5f72a201ef9cad49bd9.jpeg",
    "https://cdn.faire.com/fastly/b26c78ea65980409d37980d65487a397b283cfe636c29a6945e73b4f9db83783.jpeg",
  ],
  priceDollars: 7,
  description:
    "HOT item! Makes the perfect accessory for playing dressing up and just making a fashion statement.\nTweed Design Mini Crossbody with gold chain strap for girls; embellished with pearls and flower accents.\nFeatures a gold chain strap and snap button closure.\nMakes a great gift for daughters, nieces, moms and more!\n",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:07.092Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
